import styles from "../illustration.module.scss";
import { Diamond, Plus, Ring } from "./shapes";

const BACK_BARS = [41.29, 41.29 + 35.239, 41.29 + 70.478, 41.29 + 105.717];
const FRONT_BARS = [32.677, 32.677 + 39.546, 32.677 + 79.092, 32.677 + 118.638];

/** `ilu-select-dropdown` (10259:23827), 213×107: dois campos de seleção empilhados. */
export function Selecao() {
  return (
    <>
      <rect
        className={styles.strokeSurface100Fill50}
        x="26.01"
        y="54.12"
        width="162.1"
        height="32.11"
        rx="12.14"
        strokeWidth="0.783"
      />
      {BACK_BARS.map((x) => (
        <rect
          key={x}
          className={styles.fillSurface100}
          x={x}
          y="67.43"
          width="25.84"
          height="5.48"
          rx="2.74"
        />
      ))}
      <rect
        className={`${styles.fillSurface0} ${styles.shadowIllustration}`}
        x="17.8"
        y="20.06"
        width="178.54"
        height="39.15"
        rx="12.53"
      />
      {FRONT_BARS.map((x) => (
        <rect
          key={x}
          className={styles.fillPrimary700}
          x={x}
          y="36.9"
          width="30.15"
          height="5.48"
          rx="2.74"
        />
      ))}
      <Diamond cx={6.89} cy={15.41} />
      <Diamond cx={186.22} cy={99.99} />
      <Plus cx={210.04} cy={26.71} />
      <Plus cx={23.33} cy={5.57} />
      <Ring cx={182.63} cy={7.13} r={2.74} />
      <Ring cx={33.06} cy={102.67} r={2.74} />
    </>
  );
}
